export const SET_MAIN_NOTIFICATION_VISIBILITY = 'Notifications/SET_MAIN_NOTIFICATION_VISIBILITY';

export const setMainNotificationVisibility = (visible) => ({
    type: SET_MAIN_NOTIFICATION_VISIBILITY,
    visible,
});
